import { Button, Icons, useToggle } from '@commenda/kakashi';
import {
  TaskParty,
  TaskStatus,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';
import { BankStatementsModal } from './modal/BankStatementModal';

export const VerifyBankStatements = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { role, mutate, serviceRequest } = context;

  const bankStatementsModalVisibility = useToggle();

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="Commenda has verified Bank Statements"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Please wait while Commenda verifies your bank statements" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Please wait while Commenda verifies your bank statements" />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.COMPLETED]: {
            actions: (
              <Button
                size="sm"
                variant="secondary"
                onClick={bankStatementsModalVisibility.show}
              >
                View <Icons.ArrowNarrowRight className="size-4" />
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel
                label="Verify Bank Statements"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
          [TaskStatus.TO_DO]: {
            actions: (
              <Button
                size="sm"
                onClick={bankStatementsModalVisibility.toggle}
                variant="primary"
              >
                View bank statement{' '}
                <Icons.ArrowNarrowRight className="size-4" />
              </Button>
            ),
            label: <ServiceRequestTaskLabel label="Verify Bank Statements" />,
          },
          [TaskStatus.BACKLOG]: {
            actions: (
              <Button size="sm" disabled onClick={() => {}} variant="primary">
                Start <Icons.ArrowNarrowRight className="size-4" />
              </Button>
            ),
            label: <ServiceRequestTaskLabel label="Verify Bank Statements" />,
          },
        },
      };

      return (
        stateMap[state.role]?.[state.status] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{ role, status: task.status }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
      <BankStatementsModal
        serviceRequest={serviceRequest}
        isOpen={bankStatementsModalVisibility.visible}
        onClose={bankStatementsModalVisibility.hide}
        onSuccess={() =>
          updateTaskStatus({
            task,
            status: TaskStatus.COMPLETED,
            mutate,
          })
        }
        viewOnly={task.status === TaskStatus.COMPLETED}
      />
    </div>
  );
};
